<template>
  <div class="block md:hidden" @click="toggleMenu">
    <a class="main-menu-trigger">
      <span class="slice"></span>
      <span class="slice"></span>
      <span class="slice"></span>
      <span class="slice"></span>
      <span class="slice"></span>
      <span class="slice"></span>
      <div id="nav-icon3" :class="menu?'open':''">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    showMenu: {
      type: Boolean
    }
  },
  data() {
    return {
      menu: false
    };
  },
  watch: {
    showMenu() {
      this.menu = this.showMenu;
    }
  },
  methods: {
    toggleMenu() {
      this.menu = !this.menu;
      this.$emit("open", this.menu);
    }
  }
};
</script>
<style scoped>
.main-menu-trigger {
  position: fixed;
  top: 14px;
  left: 12px;
  display: block;
  width: 3.75em;
  height: 4.25em;
  margin: 0 auto;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  z-index: 20001;
  font-size: 11px;
}
.slice {
  border-top: 1.125em solid transparent;
  border-right: none;
  border-bottom: 1em solid transparent;
  border-left: 1.865em solid #ecc94b;
  position: absolute;
  top: 0;
  left: 50%;
  -webkit-transform-origin: left bottom;
  -ms-transform-origin: left bottom;
  transform-origin: left bottom;
  border-radius: 3px 3px 0 0;
}

.slice:nth-child(1) {
  -webkit-transform: rotateZ(60deg) rotateY(0deg) rotateX(0);
  transform: rotateZ(60deg) rotateY(0deg) rotateX(0);
}
.slice:nth-child(2) {
  -webkit-transform: rotateZ(120deg) rotateY(0deg) rotateX(0);
  transform: rotateZ(120deg) rotateY(0deg) rotateX(0);
}
.slice:nth-child(3) {
  -webkit-transform: rotateZ(180deg) rotateY(0deg) rotateX(0);
  transform: rotateZ(180deg) rotateY(0deg) rotateX(0);
}
.slice:nth-child(4) {
  -webkit-transform: rotateZ(240deg) rotateY(0deg) rotateX(0);
  transform: rotateZ(240deg) rotateY(0deg) rotateX(0);
}
.slice:nth-child(5) {
  -webkit-transform: rotateZ(300deg) rotateY(0deg) rotateX(0);
  transform: rotateZ(300deg) rotateY(0deg) rotateX(0);
}
.slice:nth-child(6) {
  -webkit-transform: rotateZ(360deg) rotateY(0deg) rotateX(0);
  transform: rotateZ(360deg) rotateY(0deg) rotateX(0);
}
#nav-icon3 {
  width: 60px;
  height: 45px;
  position: relative;
  margin: 14px 9px;

  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
}
#nav-icon3 span {
  display: block;
  position: absolute;
  height: 3.5px;
  width: 40%;
  background: white;
  border-radius: 9px;
  opacity: 1;
  left: 0;

  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}

#nav-icon3 span:nth-child(1) {
  top: 0px;
}

#nav-icon3 span:nth-child(2),
#nav-icon3 span:nth-child(3) {
  top: 8px;
}

#nav-icon3 span:nth-child(4) {
  top: 16px;
}

#nav-icon3.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#nav-icon3.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>